'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import classNames from 'classnames';
import StatusIndicator from './StatusIndicator';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class AgentAvatar extends Component {
  render() {
    const {
      AsyncUIAvatar,
      avatar,
      away,
      disabled,
      onClick,
      className,
      showStatus,
      size,
      style
    } = this.props;
    const classes = classNames('chat-head', className, disabled && 'chat-head-disabled');
    return /*#__PURE__*/_jsxs("div", {
      className: classes,
      onClick: onClick,
      "data-test-id": "agent-avatar",
      children: [/*#__PURE__*/_jsx(AsyncUIAvatar, {
        style: style,
        src: avatar,
        className: "chat-head-avatar",
        size: size,
        type: "contact"
      }), showStatus && /*#__PURE__*/_jsx(StatusIndicator, {
        away: away,
        size: size
      })]
    });
  }
}
AgentAvatar.propTypes = {
  AsyncUIAvatar: PropTypes.func.isRequired,
  avatar: PropTypes.string,
  away: PropTypes.bool.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  showStatus: PropTypes.bool.isRequired,
  size: PropTypes.string.isRequired,
  style: PropTypes.object
};
AgentAvatar.defaultProps = {
  away: false,
  disabled: false,
  online: false,
  showStatus: false,
  size: 'md'
};
AgentAvatar.displayName = 'AgentAvatar';